import { Dialog } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import ReactDOM from 'react-dom';
import { TestCase } from '../TestExecution/const/TestSummary';
import StepsLogView from '../../Pipeline/log-viewer/StepsLogView';
import { useTheme } from '../../../hooks/useTheme';

interface PropsObject {
  log: string;
  isLoading: boolean;
  isError?: string | null;
  testCase?: TestCase;
  open: boolean;
  handleClose: () => void;
}

function TestCaseLogDialog(props: Readonly<PropsObject>) {
  const { theme } = useTheme();

  return ReactDOM.createPortal(
    <ReactEDSWrapper
      fullscreen
      className="bigDialog"
      component={Dialog}
      onClose={props.handleClose}
      show={props.open}
      title={props.testCase?.test_case_name}
    >
      <div>
        <StepsLogView
          logs={props.log}
          isLoading={false}
          error={null}
          isStepCompletedButStageRunning={false}
          leftPanelOpen={false}
          theme={theme}
        />
      </div>
    </ReactEDSWrapper>,
    document.body
  );
}
export default TestCaseLogDialog;
